<script>
  import {sgettext} from '../i18n.js';

  export let title = 'title';
  export let id = 'modal';
  export let onCancel = () => {};
  export let onSave = () => console.log('Save clicked.');
  export let backdrop = true;
  export let large = false;
  export let extraLarge = false;
  export let isValid = true;
  export let blockClose = false;
  export let additional_info_needed = false;
  export let promote_to_current = false;
</script>

<style>
  .modal-footer {padding: 15px;}

  .modal-footer button {
    min-width: 80px;
    margin-left: 10px;
  }

  .modal-footer button:first-child {
    margin-right: 0;
  }

  .modal-content {
      word-break: break-word;
  }
</style>


<div class="modal fade" id={id} tabindex="-1" role="dialog" data-backdrop={backdrop} data-testid="modal-container">
  <div class={`modal-dialog ${extraLarge? 'modal-xl' : large ? 'modal-lg' : ''}`} role="document">
    <div class="modal-content">
      <div class="modal-header" style={`${promote_to_current ? 'display:block' : 'display:flex'}`}>
        <slot name="header">
          <h4 class="modal-title" data-testid="modal-title">{title}</h4>
          {#if !blockClose}
            <button type="button" on:click={onCancel} class="close" data-dismiss="modal" aria-label="Close" data-testid="close-modal-button">
              <span aria-hidden="true">&times;</span>
            </button>
          {/if}
        </slot>
      </div>
      <div class="modal-body" data-testid="modal-body">
        <slot name="body"></slot>
      </div>
      <div class="modal-footer" data-testid="modal-footer">
        <slot name="footer">
          <button
            type="button"
            class="btn btn-secondary"
            on:click={onCancel}
            data-dismiss="modal">{sgettext('$$CANCEL$$')}</button>
          <button 
            type="button" 
            on:click={onSave}
            disabled={!isValid}
            class="btn btn-primary">{sgettext('$$SAVE$$')}</button>
        </slot>
      </div>
        {#if additional_info_needed}
            <div class="modal-body">
                <slot name="additional-info"></slot>
            </div>
        {/if}
    </div>
  </div>
</div>
